/**
 * Manual Sync Use Case
 */

import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class ManualSyncUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(): Promise<{ success: boolean; message: string; data: any }> {
    return await this.repository.manualSync();
  }
}

